import React, {useEffect} from 'react'
import {setRoute} from "../../../../store/routes";
import {useLocation, useParams} from "react-router-dom";
import {constants} from "../../../../config/constants";
import {useDispatch, useSelector} from "react-redux";
import {TeamHeader} from "../header/TeamHeader";
import {CnAContainer} from "./CnAContainer";
import {getCnAData, setDatumIdOpen} from "../../../../store/user_organizations/teams/tools/connect_and_align";
import {getOrganizationTeam} from "../../../../store/user_organizations/teams/team";

export const CnA = () => {
    document.title = `Connect & Align | ${constants.website_title}`
    const {organization_id, team_id, datum_id} = useParams();
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const cna = useSelector((state:any) => state.tool_cna)

    useEffect(() => {
        dispatch(getCnAData({organization_id, team_id}))
        dispatch( getOrganizationTeam({organization_id, team_id}) );
        if(datum_id != undefined) {
            dispatch( setDatumIdOpen(datum_id) );
        }
        urlHandled()
    }, [cna.pastDate])

    const urlHandled = () => {
        dispatch(setRoute(pathname))
        window.history.replaceState(null, "CnA", "/collab")
    }

    return (
        <>
            <TeamHeader suffixRoute='/collab' />
            <CnAContainer />
        </>
    )
}
